import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from '../../config';
import useAuth from '@hooks/useAuth';
import { Role } from '@config/types';

export default function LogoSection({ reverse, isIcon, sx, to }) {
  const { user } = useAuth();
  const role = user?.role;
  const baseUrl = (import.meta.env.VITE_PUBLIC_URL ?? '').replace(/\/$/, '');
  return (
    <ButtonBase disableRipple component={Link} to={to || role === Role.LabAdmin || role == Role.User ? `${baseUrl}/` : APP_DEFAULT_PATH} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
